exports.APIM_BASE_URL = `https://ist-h-euw-portal-apim.azure-api.net`;
exports.SUB_K = "d08f23beb6d247d6a5cb12837db5a8ca";

exports.HARDWARE_PRODUCTS = () => `/api/hardware/v1/`;

exports.HASH_PASSWORD = "73b61863bf58b87d2909794558d57e579247dfa40426f5f07b54442d1e54b295";
